var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',{attrs:{"color":"success","id":"sucesso","name":"sucesso","show":_vm.validacoesSucesso,"closeButton":""},on:{"update:show":function($event){_vm.validacoesSucesso=$event}}},[_vm._v(_vm._s(_vm.message))])}
var staticRenderFns = []

export { render, staticRenderFns }